<script>
import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'

export default {
  name: 'ShowNotificacaoData',
  props: {
    notificacao: {
      type: Object,
      required: true,
    },
    equipamentoId: {
      type: String,
      required: true,
    },
    localId: {
      type: String,
      required: true,
    },
  },
  computed: {
    quantidadeSensores() {
      return (
        this.notificacao.sensores.length +
        this.notificacao.sensorEquipamento.length
      )
    },
  },
  methods: {
    copiarValor(data) {
      const el = document.createElement('textarea')
      el.value = data
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Valor copiado',
        type: Types.INFO,
      })
    },
    acaoHasEquipamentoId(acao) {
      return acao.botaoAcaoEquipamento.equipamentoId === this.equipamentoId
    },
    sensorHasEquipamentoId(sensor) {
      return sensor.equipamentoCampoId === this.equipamentoId
    },
    isAdmin() {
      return auth.isAdmin()
    },
  },
}
</script>

<template>
  <div class="pl-1 pr-1">
    <div class="row" style="align-items: center">
      <div class="col-4">
        <p class="md-title">
          {{ notificacao.notificacao.titulo }}
        </p>
      </div>

      <div class="col-8" style="text-align: right">
        <md-button @click="$emit('close')">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>

    <div class="row" style="align-items: center">
      <div
        v-if="notificacao.notificacao.notificacaoAcaos.length > 0"
        class="chip"
        style="background-color: #0066ff26"
      >
        {{ notificacao.notificacao.notificacaoAcaos.length }} Ações
      </div>

      <div
        v-if="quantidadeSensores > 0"
        class="chip ml-1 mr-1"
        style="background-color: #00bb7726"
      >
        {{ quantidadeSensores }} Expressões
      </div>

      <div
        v-if="notificacao.notificacao.sensorId"
        class="chip ml-1 mr-1"
        style="background-color: #730cf126"
      >
        Sensor
      </div>

      <md-button
        v-if="isAdmin()"
        style="background-color: #eeeeee"
        @click="
          $router.push({
            name: 'NotificacaoEditar',
            params: {
              notificacaoId: notificacao.notificacao.id,
              localId: localId,
            },
          })
        "
      >
        Editar
      </md-button>
    </div>

    <div class="row mt-2 pl-2" style="align-items: flex-start">
      <div class="md-title">Ações</div>
      <div class="inner_badge ml-1">
        {{ notificacao.notificacao.notificacaoAcaos.length }}
      </div>
    </div>

    <div class="row mt-2">
      <div
        v-for="acao in notificacao.notificacao.notificacaoAcaos"
        :key="acao.id"
        class="col-sm-12 col-md-6 mt-1"
      >
        <div
          class="card-show"
          :class="{
            'card-used': acaoHasEquipamentoId(acao),
          }"
        >
          <div class="row" style="align-items: center">
            <div class="col-1">
              <md-icon
                class="md-primary"
                :style="{
                  ['background-color']: acao.botaoAcaoEquipamento.cor,
                  ['border-radius']: '2px',
                  ['min-height']: '2vh',
                  ['min-width']: '2vh',
                }"
              />
            </div>
            <div class="col">
              <p class="md-title mt-1 mb-1">
                {{ acao.botaoAcaoEquipamento.nomeExibicao }}
              </p>
            </div>
          </div>

          <div class="row" style="align-items: center">
            <div class="col-9 pr-0">
              <p
                class="md-caption"
                style="
                  font-size: 0.9rem;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                "
              >
                {{ acao.botaoAcaoEquipamento.acao }}
              </p>
            </div>

            <div class="col-3 p-0" style="text-align: center">
              <md-button
                class="md-icon-button button-with-border"
                @click.stop="() => copiarValor(acao.botaoAcaoEquipamento.acao)"
              >
                <md-icon>content_copy</md-icon>
              </md-button>
            </div>
          </div>

          <div class="row ml-1">
            <div
              v-if="acaoHasEquipamentoId(acao)"
              class="chip ml-1 mr-1"
              style="background-color: #ffaa0066"
            >
              Vinculado
              <md-tooltip md-direction="bottom">
                Ação vinculada ao equipamento
              </md-tooltip>
            </div>

            <div
              v-else
              class="chip ml-1 mr-1"
              style="background-color: #dbdbdb66"
            >
              Não Vinculado
              <md-tooltip md-direction="bottom">
                Ação não vinculada ao equipamento
              </md-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 pl-2" style="align-items: flex-start">
      <div class="md-title">Sensores</div>
      <div class="inner_badge ml-1">
        {{ quantidadeSensores }}
      </div>
    </div>

    <div class="row mt-2">
      <div
        v-for="sensor in [
          ...notificacao.sensorEquipamento,
          ...notificacao.sensores,
        ]"
        :key="sensor.id"
        class="col-sm-12 col-md-6 mt-1"
      >
        <div
          class="card-show"
          :class="{
            'card-used': sensorHasEquipamentoId(sensor),
          }"
        >
          <div class="row" style="align-items: center">
            <div class="col">
              <p class="md-title mt-1 mb-1">
                {{ sensor.descricao }}
              </p>
            </div>
          </div>

          <p class="md-caption" style="font-weight: 500; font-size: 0.9rem">
            {{ sensor.codigoIntegracao }} - {{ sensor.tipoSensor.tipo }}
          </p>

          <div class="row ml-1">
            <div
              v-if="sensorHasEquipamentoId(sensor)"
              class="chip ml-1 mr-1"
              style="background-color: #ffaa0066"
            >
              Vinculado
              <md-tooltip md-direction="bottom">
                Sensor vinculado ao equipamento
              </md-tooltip>
            </div>
            <div
              v-else
              class="chip ml-1 mr-1"
              style="background-color: #dbdbdb66"
            >
              Não Vinculado
              <md-tooltip md-direction="bottom">
                Sensor não vinculado ao equipamento
              </md-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.chip {
  border-radius: 16px;
  background-color: #f1f1f1;

  color: #4d4d4d;

  font-size: 0.8rem;
  font-weight: 500;

  padding: 4px 8px;
}

.card-show {
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.card-used {
  border: 2px solid black;
}

.inner_badge {
  text-align: center;

  height: 20px;
  width: 20px;

  font-size: 0.9rem;

  background-color: #1b1f26b8;
  color: white;
  font-weight: bold;
  border-radius: 20px;
}
</style>
